// extracted by mini-css-extract-plugin
var _1 = "_adminsCreateAdminForm-module__button-container";
var _2 = "_adminsCreateAdminForm-module__button-subcontainer";
var _3 = "_adminsCreateAdminForm-module__container";
var _4 = "_adminsCreateAdminForm-module__form-container";
var _5 = "_adminsCreateAdminForm-module__span-2";
export { _1 as "button-container", _2 as "button-subcontainer", _3 as "container", _4 as "form-container", _5 as "span-2" }
